export enum MalouComparisonPeriod {
    PREVIOUS_PERIOD = 'previous_period',
    SAME_PERIOD_FIRST_YEAR = 'same_period_first_year',
    SAME_PERIOD_LAST_YEAR = 'same_period_last_year',
    SINCE_START = 'since_start',
}
